import { Injectable } from '@angular/core';
import { OrderCondition } from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { Converter } from '../../../../core/util';

@Injectable({ providedIn: 'root' })
export class OrderConditionNormalizer implements Converter<Occ.SapOrderCondition, OrderCondition> {
  convert(source: Occ.SapOrderCondition): OrderCondition {
    if (!source) {
      return undefined;
    }
    const {
      activeCondition,
      groupCondition,
      conditionClass,
      conditionCategory,
      rate,
      rateCurrency,
      value,
      salesDocumentCurrency,
      ...target
    } = source;
    return {
      ...target,
      active: activeCondition,
      group: groupCondition,
      clazz: conditionClass,
      category: conditionCategory,
      rate: {
        value: rate,
        currencyIso: rateCurrency,
      },
      value: {
        value: value,
        currencyIso: salesDocumentCurrency,
      },
    };
  }
}
